/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Properties_Custom_Property_CountInputs */

const en_tables_custom_properties_custom_property_count = /** @type {(inputs: Tables_Custom_Properties_Custom_Property_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Properties Custom Property Count`)
};

const de_tables_custom_properties_custom_property_count = /** @type {(inputs: Tables_Custom_Properties_Custom_Property_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Property Anzahl`)
};

/**
* | output |
* | --- |
* | "Properties Custom Property Count" |
*
* @param {Tables_Custom_Properties_Custom_Property_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_properties_custom_property_count = /** @type {((inputs?: Tables_Custom_Properties_Custom_Property_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Properties_Custom_Property_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_properties_custom_property_count(inputs)
	return de_tables_custom_properties_custom_property_count(inputs)
});